<template>
	<div class="add-order">
		<div
		 class="add-order__container"
		 v-if="everythingIsLoaded"
		>
			<div class="add-order__top">
				<button
				 class="add-order__close button--no"
				 v-if="otherOrders"
				 @click="goToLastOrder()"
				>
					<icon name="close" />
				</button>
				<div class="add-order__title">{{resource('pageTitle')}}</div>
				<div class="add-order__search-bar">
					<input
					 type="search"
					 :placeholder="resource('searchPlaceholder')"
					 class="add-order__search-input"
					 v-model="search"
					>
					<icon
					 class="add-order__search-icon"
					 name="search"
					 size="24px"
					/>
				</div>
			</div>
			<div class="add-order__body">
				<div
				 class="client"
				 v-for="client in shownClients"
				 v-if="typeof shownClients === 'object'"
				 :key="client.key"
				>
					<div class="client__name">{{ client.name }}</div>
					<div class="client__adress">{{ client.address.line1 }}, {{ client.address.city }}, {{ client.address.zipCode }}</div>
					<button
					 class="client__select-button button--primary"
					 @click="addOrder(client)"
					>{{resource('selectCustomer')}}</button>
				</div>
				<div
				 class="no-result"
				 v-if="shownClients.length === 0 && typeof shownClients === 'object'"
				>{{resource('noResult')}}</div>
				<div
				 class="start-search"
				 v-if="shownClients === 'start'"
				>
					<icon
					 name="search"
					 size="3vw"
					/>
					<div class="start-search__text">{{resource('beginSearch')}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Fuse from 'fuse.js'
import { EventBus } from './../event-bus.js'


export default {
	name: 'addOrder',
	created() {
		let $this = this
		if (this.userIsRetailer) {
			this.handleRetailer()
		}

		EventBus.$on('clientsLoaded', () => {
			$this.loadedClients = true
			// Compare user email with retailer emails
			$this.$store.dispatch('isRetailer').then(()=>{
				if (this.userIsRetailer) {
					this.handleRetailer(true)
				}
			})
		})
		EventBus.$on('productsLoaded', () => {
			$this.loadedProducts = true
			if (this.userIsRetailer) {
				this.handleRetailer(true)
			}
		})

		EventBus.$on('ordersLoaded', () => {
			$this.loadedOrders = true
			if (this.userIsRetailer) {
				this.handleRetailer(true)
			}
		})
	},
	computed: {
		userIsRetailer(){
			return this.$store.state.retailerClient
		},
		everythingIsLoaded(){
			if(this.loadedClients && this.loadedProducts && this.loadedOrders || !this.$store.state.app.syncing.threads){
				return true
			}
			return false
		},
		otherOrders() {
			if (this.$store.getters.lastOrder) {
				return true
			} else {
				return false
			}
		},
		shownClients() {
			var shownItems
			if (this.search === '') {
				if (this.noSearchYet) {
					shownItems = 'start'
				} else {
					shownItems = []
				}
			} else {
				var allClients = this.$store.getters.getClients
				var searchQuery = this.search
				var options = {
					shouldSort: true,
					threshold: 0.2,
					location: 0,
					distance: 100,
					maxPatternLength: 32,
					minMatchCharLength: 1,
					keys: [
						'name',
						'address.line1',
						'address.city',
						'address.zipCode'
					]
				}
				var fuse = new Fuse(allClients, options)
				shownItems = fuse.search(searchQuery)
			}
			return shownItems
		}
	},
	watch: {
		shownClients() {
			if (this.search !== '') {
				this.noSearchYet = false
			}
		}
	},
	methods: {
		resource(item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		uuidv4() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
				/[xy]/g,
				function(c) {
					var r = (Math.random() * 16) | 0
					var v = c === 'x' ? r : (r & 0x3) | 0x8
					return v.toString(16)
				}
			)
		},
		addOrder(client) {
			var order = {
				id: this.uuidv4(),
				client: client,
				added: new Date(),
				cart: []
			}
			this.$store.dispatch('newOrder', order)
			this.$router.push({
				name: 'order',
				params: { orderId: order.id, order: order }
			})
		},
		goToLastOrder() {
			var lastOrder
			if (this.$store.getters.order) {
				lastOrder = this.$store.getters.order
			} else {
				lastOrder = this.$store.getters.lastOrder
			}
			this.$router.push({
				name: 'order',
				params: { orderId: lastOrder.id, order: lastOrder }
			})
		},
		handleRetailer(init) {
			const $this = this
			if (
				($this.loadedClients &&
					$this.loadedProducts &&
					$this.loadedOrders) ||
				$this.$store.state.app.isLoaded
			) {
				$this.$store.commit('setLoaded', true)
				if (init) {
					let lastOrder = $this.$store.getters.lastOrder
					if (lastOrder) {
						$this.$router.push({
							name: 'order',
							params: { orderId: lastOrder.id, order: lastOrder }
						})
					} else {
						$this.addOrder($this.$store.getters.getRetailerClient)
					}
				} else {
					$this.addOrder($this.$store.getters.getRetailerClient)
				}
			} else if ($this.$store.state.app.activeOrder) {
				// this is triggered when app is initialised from orderpage
				// since active order is only set at order page and nothing is "loaded".
				$this.addOrder($this.$store.getters.getRetailerClient)
			}
		}
	},
	data() {
		return {
			loadedClients: false,
			loadedProducts: false,
			loadedOrders: false,
			search: '',
			noSearchYet: true,
			res: {
				nl: {
					pageTitle: 'Nieuwe order aanmaken',
					searchPlaceholder: 'Zoek op winkelnaam of locatie',
					selectCustomer: 'Selecteer klant',
					noResult: 'Geen klanten gevonden',
					beginSearch: 'Start met zoeken'
				},
				fr: {
					pageTitle: 'Créer une nouvelle commande',
					searchPlaceholder:
						'Rechercher par nom de magasin ou par lieu',
					selectCustomer: 'Choisir un client',
					noResult: 'Aucun client trouvé',
					beginSearch: 'Commencer à chercher'
				}
			}
		}
	}
}
</script>

<style lang="scss">
$overlay-bg: rgba(38, 54, 76, 0.9);
$popup-bg: #fff;
$block-bg: #f5f5f5;

.add-order {
	height: calc(100vh - 60px); //60px = header height
	background: $overlay-bg;
	display: flex;
	justify-content: center;
	align-items: center;
	&__container {
		background: $popup-bg;
		max-width: 90%;
		max-height: 90%;
		width: 100%;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}
	&__title {
		font-size: $h1;
		line-height: $h1 * 1.8;
		font-weight: bold;
		margin: 0 0 $content;
	}
	&__top {
		background: $add-order__top-bg;
		color: $add-order__top-color;
		padding: $content $container $container;
		position: relative;
		flex: 0 0 auto;
	}
	&__search-bar {
		border: 1px solid #ccc;
		background: #fff;
		display: flex;
		align-items: stretch;
		height: 40px;
		color: $text;
	}
	&__search-input {
		flex: 1 1 auto;
		border: none;
		padding: 0 $content;
		color: inherit;
	}
	&__search-icon {
		flex: 0 0 auto;
		margin: 0 $content;
	}
	&__body {
		overflow: auto;
		flex: 1 1 auto;
		position: relative;
	}
	&__close {
		position: absolute;
		right: $content;
		top: $content;
	}
}

.client {
	padding: $content;
	border-bottom: 1px solid $add-order__border;
	display: flex;
	align-items: center;
	font-size: $fs1;
	&__name {
		font-weight: bold;
		width: 40%;
		flex: 0 0 auto;
	}
	&__adress {
		width: 36%;
		flex: 0 0 auto;
		margin: 0 2%;
	}
	&__select-button {
		flex: 0 0 auto;
		justify-content: flex-end;
		padding: 1em;
		font-size: $fs1;
		margin-left: auto;
	}
}
.no-result {
	font-size: $h1;
	font-weight: bold;
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.start-search {
	font-size: $h1;
	font-weight: bold;
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	&__text {
		margin-top: $container;
	}
}
</style>
